<template>
  <div style="height: 100%">
    <div style="height: 100%; position: relative" class="box">
      <!--      线绕-->
      <el-carousel v-if="accountNo=='01.01'" :height="screenheight" :interval="120000">
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen99_241118_171356`"/>
        </el-carousel-item>
<!--        <el-carousel-item>-->
<!--          <iframe-->
<!--              frameborder="0"-->
<!--              height="100%"-->
<!--              width="100%"-->
<!--              :src="`${fullUrl}/datav/index.html#/preview?name=screen88_240703_202658"/>-->
<!--        </el-carousel-item>-->
      </el-carousel>
      <el-carousel v-if="accountNo=='02.01'" :height="screenheight" :interval="120000">
        <el-carousel-item>
          <iframe
              frameborder="0"
              height="100%"
              width="100%"
              :src="`${fullUrl}/datav/index.html#/preview?name=screen104_241118_172828`"/>
        </el-carousel-item>
      </el-carousel>


      <div class="test" @click="fullScreen">
        <i v-if="!isFullscreen" title="全屏" class="el-icon-full-screen"/>
        <i v-else title="还原" class="el-icon-aim"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Kb1",
    data() {
      return {
        screenheight: document.documentElement.clientHeight - 80 + "px",
        isFullscreen: false,
        accountNo: window.config.accountNo,
        fullUrl:window.config.fullServerUrl,
      };
    },

    mounted() {
      window.onresize = () => {
        if (!this.isFullscreen) {
          this.screenheight = document.documentElement.clientHeight - 80 + "px";
        } else {
          this.screenheight = document.documentElement.clientHeight + "px";
        }
      };
    },

    methods: {
      fullScreen() {
        let fullscreenEnabled =
          document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
        if (fullscreenEnabled) {
          let element = document.getElementsByClassName("box")[0];
          if (this.isFullscreen) {
            // 关闭全屏
            if (element.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            }
          } else {
            if (element.requestFullscreen) {
              element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
              element.mozRequestFullScreen();
            } else if (element.webkitRequestFullScreen) {
              element.webkitRequestFullScreen();
            }
          }
          this.isFullscreen = !this.isFullscreen;
        }
      },
    },
  };
</script>

<style scoped>
.test {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
}
i {
  font-size: 26px;
  color: #fff;
  cursor: pointer;
  display: none;
}
.box:hover i {
  display: block;
}
</style>
